module.exports = __webpack_public_path__ + "img/wechat-img3.e2bef664.png";